import { actionCreator, appointmentTypeActionTypes, checkHttpStatus, GET_APPOINTMENT_TYPE_LIST_API, jsonApiHeader, 
  POST_APPOINTMENT_TYPE_API, showErrorMessage, showSuccessMessage, showWarningMessage, DELETE_APPOINTMENT_TYPE_API, GET_APPOINTMENT_TYPE_DETAIL_API, GET_MASTERDATABYNAME } from './../constants/ApiConstants';
import Alert from 'react-s-alert';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI } from '../../../../../actions/utilAction';



export const getMasterData = (masterData) => {    
  return (dispatch, getState) => {
      dispatch(actionCreator(appointmentTypeActionTypes.get_masterData.REQUEST));
      fetch(`${GET_MASTERDATABYNAME}`, {
          method: 'post',
          body: JSON.stringify(masterData),
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
          .then(function (response) {                
              dispatch(actionCreator(appointmentTypeActionTypes.get_masterData.SUCCESS, response));
          })
          .catch(function (error) {
              console.log('error getMasterData ..', error);
          });
  };
};

export const getAppointmentTypeList = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(appointmentTypeActionTypes.get_appointmentTypeList.REQUEST));
    fetch(`${GET_APPOINTMENT_TYPE_LIST_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(appointmentTypeActionTypes.get_appointmentTypeList.SUCCESS, response));
        } else {
          dispatch(actionCreator(appointmentTypeActionTypes.get_appointmentTypeList.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error get_appointmentTypeList', error);
      });
  };
};

export const getAppointmentTypeDetail = (appointmentTypeId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(appointmentTypeActionTypes.get_appointmentTypeDetail.REQUEST));
    fetch(`${GET_APPOINTMENT_TYPE_DETAIL_API}?id=${appointmentTypeId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(appointmentTypeActionTypes.get_appointmentTypeDetail.SUCCESS, response));
        } else {
          dispatch(actionCreator(appointmentTypeActionTypes.get_appointmentTypeDetail.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error get_appointmentTypeDetail', error);
      });
  };
};

export const saveAppointmentType = (formProps) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(appointmentTypeActionTypes.save_appointmentType.REQUEST));
    fetch(`${POST_APPOINTMENT_TYPE_API}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(formProps),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(appointmentTypeActionTypes.save_appointmentType.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(appointmentTypeActionTypes.save_appointmentType.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error save_appointmentType', error);
      });
  };
};

export const deleteAppointmentType = (appointmentTypeId) => {
  Alert.closeAll();
  return (dispatch, getState) => {
    dispatch(actionCreator(appointmentTypeActionTypes.delete_appointmentType.REQUEST));
    fetch(`${DELETE_APPOINTMENT_TYPE_API}?id=${appointmentTypeId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(appointmentTypeActionTypes.delete_appointmentType.SUCCESS, response));
        } else if (response.statusCode === 401 || response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(appointmentTypeActionTypes.delete_appointmentType.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(appointmentTypeActionTypes.delete_appointmentType.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error delete_appointmentType', error);
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/appointment-type/actions/AppointmentTypeActions.js